/* Button Menus */

var wexButtonMenu = {

  init: function(buttonMenuObject) {
    this.bindUIfunctions(buttonMenuObject);
  },

  bindUIfunctions: function(buttonMenuObject) {
    $(buttonMenuObject).on('click', '[data-trigger-buttonmenu]', function(event){

      console.log('click');

      var e = event,
          toggledButton = event.target,
          targetMenu = $(toggledButton).closest('.wex-button-menu-wrapper').find('.wex-button-menu'),
          targetMenuItems = $(toggledButton).closest('.wex-button-menu-wrapper').find('.wex-button-menu .tabs-title'),
          buttonMenuArray = $('[data-trigger-buttonmenu]').not(toggledButton);


          

          $(targetMenuItems).on('click', function(event){
            wexButtonMenu.close(toggledButton, targetMenu);
          });

      // Close any other menus that are open
      
        $(buttonMenuArray).each(function(key, value){
          var button = $(buttonMenuArray)[key],
              menu =  $(button).closest('.wex-button-menu-wrapper').find('.wex-button-menu');

          if($(button).attr('aria-expanded') === 'true'){
            wexButtonMenu.close(button, menu);
          }
        });
      

      if ( $(targetMenu).hasClass('show') ) {
        wexButtonMenu.close(toggledButton, targetMenu);
      } else {
        wexButtonMenu.open(toggledButton, targetMenu);
      }

      $(targetMenu).keydown(function(event){
        wexKeyboardFunc(event, this, {arg1:toggledButton, arg2:targetMenu}, wexButtonMenu.close);
      });
    });

    // Listen for clicks outside of the button menus
    var touchmoved;

    $(document).on("click", function(event) {
    
      console.log(event.target);

      if(!$(event.target).is('[data-trigger-buttonmenu]')) {
        var buttonMenuArray = $('[data-trigger-buttonmenu]');

        // Close any other menus that are open
        if(touchmoved !== true){
            $(buttonMenuArray).each(function(key, value){
            var button = $(buttonMenuArray)[key],
                menu =  $(button).closest('.wex-button-menu-wrapper').find('.wex-button-menu');

            if($(button).attr('aria-expanded') === 'true'){
              wexButtonMenu.close(button, menu);
            }
          });
        }
        
      }
    }).on('touchmove', function(e){
        touchmoved = true;
    }).on('touchstart', function(){
        touchmoved = false;
    });
  },

  open: function(toggledButton, targetMenu){
    $(targetMenu).addClass('show').attr({
      'aria-hidden': 'false'
    }).removeAttr('tabindex');

    $(toggledButton).attr('aria-expanded', 'true');
  },

  close: function(toggledButton, targetMenu) {
    $(targetMenu).removeClass('show').attr({
      'aria-hidden': 'true',
      'tabindex': '-1'
    });

    $(toggledButton).attr('aria-expanded', 'false');
  }
};

$('.wex-button-menu-wrapper').each(function(){
  wexButtonMenu.init(this);
});

// Add keyboard funtionality for moving within an component that has focusable elements
function wexKeyboardFunc(event, element, args, escapeFunction) {
  var focusableElements = $(element).find(':focusable'),
      ev = event;

  // Move to previous focusable element
  if (ev.keyCode === 37 || ev.keyCode === 38) {
    var prev = focusableElements[($.inArray(document.activeElement, focusableElements) - 1 + focusableElements.length) % focusableElements.length];
    prev.focus();
  }

  // Move to next focusable element
  if (ev.keyCode === 39 || ev.keyCode === 40) {
    var next = focusableElements[($.inArray(document.activeElement, focusableElements) + 1) % focusableElements.length];
    next.focus();
  }

  // ESCAPE
  if (ev.keyCode === 27) {
    escapeFunction(args.arg1, args.arg2);
  }
}